"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/TMFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_229)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_229`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-5.76001 0.000244141H30.24V23.9998H-5.76001V0.000244141Z",
					fill: "#496E2D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M19.3561 6.91495C19.9465 5.26935 19.2832 3.47961 17.8598 2.58819C18.1207 2.62197 18.3773 2.68376 18.6251 2.77248C20.5236 3.45367 21.5105 5.54477 20.8294 7.44342C20.1482 9.34207 18.0571 10.3289 16.1584 9.64771C15.9108 9.55871 15.6734 9.44332 15.4504 9.30353C17.1159 9.52038 18.7657 8.56061 19.3561 6.91495ZM16.0816 2.13721L15.5685 2.80004L14.7796 2.51697L15.2515 3.20968L14.7385 3.87252L15.5431 3.63782L16.015 4.33054L16.0404 3.49283L16.8451 3.25806L16.0561 2.97505L16.0816 2.13721Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M17.4669 4.29717L16.9539 4.96001L16.1649 4.67693L16.6368 5.36965L16.1238 6.03249L16.9284 5.79771L17.4004 6.4905L17.4257 5.65273L18.2304 5.41788L17.4414 5.13495L17.4669 4.29717ZM13.6392 2.92383L13.1262 3.58666L12.3374 3.30373L12.8092 3.99638L12.2962 4.65914L13.1008 4.42444L13.5728 5.11716L13.5981 4.27938L14.4028 4.04475L13.6138 3.7616L13.6392 2.92383ZM13.583 5.39806L13.07 6.06089L12.2811 5.77781L12.753 6.47053L12.24 7.13337L13.0446 6.89867L13.5165 7.59139L13.542 6.75361L14.3466 6.51891L13.5576 6.23583L13.583 5.39806ZM15.9374 6.24272L15.4244 6.90556L14.6355 6.62248L15.1074 7.31527L14.5943 7.97804L15.399 7.74333L15.8709 8.43605L15.8962 7.59828L16.7008 7.36357L15.912 7.08057L15.9374 6.24272Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0.109619 0.000244141H6.37046V23.9998H0.109619V0.000244141Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.49866 6.318L1.45044 5.53718V4.43292L2.49866 3.6521H3.98113L5.02935 4.43292V5.53718L3.98113 6.318H2.49866Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M3.23989 3.6521H2.49866L1.45044 4.43292V4.97278H3.23989V3.6521ZM3.23989 6.318H3.98113L5.02935 5.53718V4.97384H3.23989V6.318Z",
					fill: "#FF9811"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.49866 20.3478L1.45044 19.5669V18.4627L2.49866 17.6819H3.98113L5.02935 18.4627V19.5669L3.98113 20.3478H2.49866Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M3.23989 17.6819H2.49866L1.45044 18.4627V19.0026H3.23989V17.6819ZM3.23989 20.3478H3.98113L5.02935 19.5669V19.0036H3.23989V20.3478Z",
					fill: "#FF9811"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.49867 13.333L1.45045 12.5521V11.448L2.49867 10.6671H3.98114L5.02936 11.448V12.5521L3.98114 13.333H2.49867ZM5.06599 15.051H4.60945V14.5944H3.80712L3.23984 14.0272L2.67262 14.5944H1.87036V15.051H1.41382V15.9641H1.87036V16.4205H2.67262L3.23991 16.9879L3.80719 16.4205H4.60945V15.9641H5.06599V15.051ZM5.06599 8.03603H4.60945V7.57956H3.80712L3.23984 7.01221L2.67262 7.57956H1.87036V8.03603H1.41382V8.94911H1.87036V9.40558H2.67262L3.23991 9.973L3.80719 9.40558H4.60945V8.94911H5.06599V8.03603Z",
					fill: "#496E2D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.71802 11.478H3.76146V12.5215H2.71802V11.478Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M3.24005 9.01404C3.52823 9.01404 3.76184 8.78043 3.76184 8.49225C3.76184 8.20407 3.52823 7.97046 3.24005 7.97046C2.95187 7.97046 2.71826 8.20407 2.71826 8.49225C2.71826 8.78043 2.95187 9.01404 3.24005 9.01404Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M3.24005 16.0294C3.52823 16.0294 3.76184 15.7958 3.76184 15.5076C3.76184 15.2195 3.52823 14.9858 3.24005 14.9858C2.95187 14.9858 2.71826 15.2195 2.71826 15.5076C2.71826 15.7958 2.95187 16.0294 3.24005 16.0294Z",
					fill: "#D80027"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_229`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as TMFlag };
